var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container maintenancement" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12 text-center mt-3" }, [
        _c("img", {
          staticClass: "maintenancement--image",
          attrs: {
            alt: "error-503",
            src: _vm.assetsPathModule("/error503.png"),
          },
        }),
        _vm._v(" "),
        _c("h1", { staticClass: "maintenancement--title mb-3 mb-sm-5" }, [
          _vm._v("Serviço em manutenção"),
        ]),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "btn btn-dark mt-3 mt-sm-4",
            attrs: { href: "/" },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.goHome()
              },
            },
          },
          [_vm._v("Home")]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12 text-center py-3" }, [
        _c("div", { staticClass: "maintenancement--footer" }, [
          _c(
            "a",
            {
              attrs: { href: "/" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.goHome()
                },
              },
            },
            [
              _c("img", {
                attrs: {
                  src: _vm.assetsPathGlobalPlatform("/logo-header.svg"),
                },
              }),
            ]
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h2", { staticClass: "maintenancement--text" }, [
      _vm._v("\n                Estamos a trabalhar para si. "),
      _c("br"),
      _vm._v("\n                Prometemos ser breves\n            "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }